export default __webpack_public_path__ + "106d3a24c86daf17f5b0c93e15b8175d.svg";